import {Component} from "react";

class SidebarForm extends Component {

    render() {
        return null;
    }
}

export default SidebarForm;
